import { SessionError } from "shared/errors";

export class SessionService {
    httpClient;
    baseUrl;

    constructor(baseUrl, apiClient) {
        this.httpClient = apiClient;
        this.baseUrl = baseUrl;
    }

    startSession = async () => {
        const url = `${this.baseUrl}/interaction/session/start`;
        const response = await this.httpClient.post(url);

        if (response.isSuccessful === false) {
            throw new SessionError(response, "Unable to start session.")
        }

        return response.data;
    };

    logoutSession = async () => {
        const url = `${this.baseUrl}/interaction/session/logout`;
        const response = await this.httpClient.post(url);

        if (response.isSuccessful === false) {
            throw new SessionError(response, "Unable to end session.")
        }

        return response.data;
    };

    startConversation = async (payload) => {
        const url = `${this.baseUrl}/interaction/conversation/start`;
        const response = await this.httpClient.post(url, payload);

        if (response.isSuccessful === false) {
            throw new SessionError(response, "Unable to start conversation.")
        }

        return response.data;
    };

    endConversation = async (payload) => {
        const url = `${this.baseUrl}/interaction/conversation/end`;
        const response = await this.httpClient.post(url, payload);

        if (response.isSuccessful === false) {
            throw new SessionError(response, "Unable to end conversation.")
        }

        return response.data;
    };
}
